import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61332868"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade bgModalAtendida",
  id: "citaAtendidaModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  ref: "detalleCitaModalRef",
  tabindex: "-2",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-450px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header pt-5 pb-3 px-10" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-left fs-2 fw-bold" }, "Cita atendida")
], -1))
const _hoisted_5 = { class: "modal-body scroll-y px-10" }
const _hoisted_6 = { class: "row mb-2" }
const _hoisted_7 = { class: "col-12 text-start" }
const _hoisted_8 = { class: "p-0 lst-none" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, [
    /*#__PURE__*/_createTextVNode("Comentarios"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " *")
  ])
], -1))
const _hoisted_10 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_11 = { class: "col-12 text-start" }
const _hoisted_12 = { class: "p-0 lst-none" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, [
    /*#__PURE__*/_createTextVNode("¿Se realizó inspección?"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " *")
  ])
], -1))
const _hoisted_14 = {
  class: "yesno fs-base",
  style: {"display":"inline-flex","list-style-type":"none","padding":"0px"}
}
const _hoisted_15 = { class: "me-3" }
const _hoisted_16 = {
  key: 0,
  class: "col-12 text-start"
}
const _hoisted_17 = { class: "p-0 lst-none" }
const _hoisted_18 = { class: "mb-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, [
  /*#__PURE__*/_createTextVNode("Diagnóstico"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, " *")
], -1))
const _hoisted_20 = { class: "borderDotted text-center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "contentDropZone" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { class: "lst-none mb-5" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-3" }, "Arrastra el archivo de diagnóstico")
], -1))
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "d-flex flex-column p-2" }
const _hoisted_29 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_30 = {
  type: "button",
  class: "btn btn-danger btn-sm btntrash-rounded",
  title: "Eliminar imagen"
}
const _hoisted_31 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_32 = { class: "lst-none mt-5" }
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = { class: "row mb-2" }
const _hoisted_35 = { class: "col-12 text-center" }
const _hoisted_36 = { class: "lst-none inFlex ps-0" }
const _hoisted_37 = { class: "me-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Descartar", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-base" }, "Guardar resultados", -1))
const _hoisted_41 = [
  _hoisted_40
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_loaderClientVue, { showLoader: _ctx.loading }, null, 8, ["showLoader"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.sendData,
            "validation-schema": _ctx.validation,
            novalidate: "novalidate"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("ul", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("li", null, [
                      _createVNode(_component_Field, {
                        name: "comment",
                        ref: "comment",
                        modelValue: _ctx.formData.comment,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.comment) = $event)),
                        as: "textarea",
                        class: "form-control form-control-sm fs-base form-control-solid borderGray",
                        rows: "3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "comment"
                      })
                    ])
                  ])
                ])
              ]),
              (_ctx.typemeeting == 1 || _ctx.typemeeting == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("ul", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("li", null, [
                          _createElementVNode("ul", _hoisted_14, [
                            _createElementVNode("li", _hoisted_15, [
                              _createElementVNode("label", {
                                for: "option-yes",
                                class: _normalizeClass({
                            'btn btn-primary':
                              _ctx.formData.inspection && _ctx.formData.inspection != null,
                            'btn btn-secondary btnBg borderGray border':
                              !_ctx.formData.inspection || _ctx.formData.inspection == null,
                          })
                              }, [
                                _createTextVNode("Sí "),
                                _createVNode(_component_Field, {
                                  type: "radio",
                                  id: "option-yes",
                                  name: "inspection",
                                  value: true,
                                  modelValue: _ctx.formData.inspection,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.inspection) = $event))
                                }, null, 8, ["modelValue"])
                              ], 2)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("label", {
                                for: "option-no",
                                class: _normalizeClass({
                            'btn btn-secondary btnBg borderGray border:':
                              _ctx.formData.inspection || _ctx.formData.inspection == null,
                            'btn btn-primary':
                              !_ctx.formData.inspection && _ctx.formData.inspection != null,
                          })
                              }, [
                                _createTextVNode("No "),
                                _createVNode(_component_Field, {
                                  type: "radio",
                                  id: "option-no",
                                  name: "inspection",
                                  value: false,
                                  modelValue: _ctx.formData.inspection,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.inspection) = $event))
                                }, null, 8, ["modelValue"])
                              ], 2)
                            ])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "inspection"
                          })
                        ])
                      ])
                    ]),
                    (_ctx.formData.inspection && _ctx.formData.inspection != null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("ul", _hoisted_17, [
                            _createElementVNode("li", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_ErrorMessage, {
                                class: "fv-plugins-message-container invalid-feedback",
                                name: "inputFile"
                              })
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_20, [
                                (!_ctx.fileload)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "file",
                                        name: "inputFile",
                                        accept: "image/jpeg,image/png,application/pdf",
                                        id: "inputFile",
                                        ref: "inputFile",
                                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getFilesInput && _ctx.getFilesInput(...args)))
                                      }, null, 544), [
                                        [_vShow, false]
                                      ]),
                                      _createElementVNode("div", {
                                        onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dropEvent && _ctx.dropEvent(...args)), ["prevent"])),
                                        onDragenter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
                                        onDragover: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkData && _ctx.checkData(...args))),
                                        class: _normalizeClass(
                            (_ctx.files.length == 0 && !_ctx.isEdit) ||
                            (_ctx.isEdit && _ctx.files.length == 0)
                              ? 'dropZone dzBorder'
                              : 'dropZoneAuto'
                          )
                                      }, [
                                        _withDirectives(_createElementVNode("div", _hoisted_22, [
                                          _createVNode(_component_inline_svg, {
                                            src: "media/icons/iconsax/document-text-1.svg",
                                            class: "mt-5 mb-3"
                                          }),
                                          _hoisted_23,
                                          _createElementVNode("ul", _hoisted_24, [
                                            _hoisted_25,
                                            _createElementVNode("li", null, [
                                              _createElementVNode("span", _hoisted_26, [
                                                _createTextVNode("o "),
                                                _createElementVNode("a", {
                                                  href: "javascript:void(0)",
                                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.agregarImagenes && _ctx.agregarImagenes(...args)))
                                                }, "selecciónalo de una carpeta")
                                              ])
                                            ])
                                          ])
                                        ], 512), [
                                          [_vShow, 
                              (_ctx.files.length == 0 && !_ctx.isEdit) ||
                              (_ctx.isEdit && _ctx.files.length == 0)
                            ]
                                        ])
                                      ], 34)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("button", _hoisted_30, [
                                            _createVNode(_component_inline_svg, {
                                              src: "media/icons/iconsax/trash.svg",
                                              class: "trashButton",
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.eliminarImagen(_ctx.index)))
                                            })
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createVNode(_component_inline_svg, {
                                            src: "media/icons/iconsax/document-text-1.svg",
                                            height: "70",
                                            width: "70",
                                            class: "mb-5"
                                          }),
                                          _createElementVNode("ul", _hoisted_32, [
                                            _createElementVNode("li", null, [
                                              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formData.file.name), 1)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("ul", _hoisted_36, [
                    _createElementVNode("li", _hoisted_37, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeAtendida && _ctx.closeAtendida(...args))),
                        class: "btn btn-secondary",
                        "data-bs-dismiss": "modal"
                      }, _hoisted_39)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.sendData && _ctx.sendData(...args)))
                      }, _hoisted_41)
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}